import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/encore/footer';
import Header from '../components/encore/header';
import HomePage from '../pages/encore/home_page';
import AboutPage from '../pages/encore/about_page';
import ContactPage from '../pages/encore/contact_page';

export default function EncoreTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
            />
            <Footer />
        </React.Fragment>
    )
}
